export let toggleLeftPaneCommand = "MJU0Te";
export default {toggleLeftPaneCommand};